module.exports = __webpack_public_path__ + "static/styleguide-0a1a68005a6b1e1e1120dae02ac47c91.mp4";